// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a6562391","453":"dabf6dca"}[chunkId] + ".chunk.js";
};